import translationEN from 'assets/locales/EN/translation.json';
import translationAR from 'assets/locales/AR/translation.json';
import Code from 'enum/lang-code.enum';
import Storages from 'storages';
import StorageKeys from 'enum/storages.enum';

// Language detection function
const detectLanguage = () => {
  const storedLang = Storages.MainStorage.getItem(StorageKeys.Keys.LANGUAGECODE);
  if (storedLang && (storedLang === Code.EN || storedLang === Code.AR)) {
    return storedLang; // Use stored language if valid
  }

  const browserLang = navigator.languages ? navigator.languages[0] : navigator.language; // Get the preferred language
  const langCode = browserLang.includes('ar') ? Code.AR : Code.EN; // Fallback to English if not Arabic
  return langCode; // Return detected language code
};

const translations = {
  [Code.EN]: translationEN,
  [Code.AR]: translationAR,
};

let currentLang = detectLanguage();

let currentLocale;
const detectLocale = () => {
  currentLocale = currentLang == Code.AR ? 'ar-AE' : 'en-US';
};
detectLocale();

export const setLanguage = (lang) => {
  if (translations[lang]) {
    currentLang = lang;
  } else {
    console.warn(`Language ${lang} not found, falling back to English.`);
    currentLang = Code.EN;
  }
  detectLocale();
};

export const translate = (key) => {
  const keys = key.split('.');
  let result = translations[currentLang];

  for (const k of keys) {
    result = result[k];
    if (!result) return key; // Return the key if not found
  }

  return result || key; // Return the translation or the key if not found
};

// Export the current language
export const getCurrentLanguage = () => currentLang;

export const getCurrentLocale = () => currentLocale;

export const getLocaleCode = (langCode) => {
  const localeCodes = Object.values(Code);
  const extractedLanCode = localeCodes.filter(
    (localeCode) => localeCode.split('_')[0].toUpperCase() === langCode
  )[0];
  return extractedLanCode
    ? extractedLanCode
    : localeCodes.filter((cod) => cod.split('_')[0].toUpperCase() === 'EN')[0];
};

// Get English language ID from available languages
export const getEnglishLanguageId = () => {
  const languages = Storages.MainStorage.getItem(StorageKeys.Keys.LANGUAGE);
  if (!languages || !languages.length) return null;

  const englishLang = languages.find(
    (lang) => lang.language_code.toLowerCase() === Code.EN.split('_')[0].toLowerCase()
  );
  return englishLang ? englishLang.id : null;
};
